import { createApi } from '@reduxjs/toolkit/query/react';

import { IMyCourse } from '@/interfaces/course';
import { IHighlightsPackage } from '@/interfaces/packages';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { axiosBaseQuery } from './query';

export const packageApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'packageApi',
  endpoints(build) {
    return {
      getPackages: build.query<IPaginationResponse<IHighlightsPackage[]>, Partial<IPaginationParams>>({
        forceRefetch({ currentArg, previousArg }) {
          return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
        },
        serializeQueryArgs: ({ queryArgs }) => {
          return JSON.stringify(queryArgs);
        },
        merge: (currCache, newCache) => {
          currCache.total_pages = newCache.total_pages;
          currCache.page = newCache.page;
          currCache.links = newCache.links;

          if (newCache.page.page === 1) {
            currCache.data = newCache.data;
          } else {
            currCache.data.push(...newCache.data);
          }
        },
        query: params => ({
          url: '/learner/showcase/packages',
          params: {
            ...params
          }
        })
      }),
      getPackageCourses: build.query<IPaginationResponse<IMyCourse[]>, Partial<IPaginationParams> & { hash: string }>({
        forceRefetch({ currentArg, previousArg }) {
          return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
        },
        serializeQueryArgs: ({ endpointName }) => {
          return endpointName;
        },
        merge: (currCache, newCache) => {
          currCache.total_pages = newCache.total_pages;
          currCache.page = newCache.page;
          currCache.links = newCache.links;

          if (newCache.page.page === 1) {
            currCache.data = newCache.data;
          } else {
            currCache.data.push(...newCache.data);
          }
        },
        query: ({ hash, ...params }) => ({
          url: `/learner/showcase/packages/${hash}/courses`,
          params: {
            ...params
          }
        })
      })
    };
  }
});

export const { useGetPackagesQuery } = packageApi;
